// src/components/CustomerSelect.tsx
import React, { useEffect, useState } from 'react';
import useCustomerStore, { CariData } from '../stores/useCustomerStore';

// Custom normalization to map Turkish characters to their simple Latin equivalents.
function normalizeTurkish(str: string): string {
  return str
    .replace(/İ/g, 'i')
    .replace(/I/g, 'i')
    .replace(/ı/g, 'i')
    .replace(/Ş/g, 's')
    .replace(/ş/g, 's')
    .replace(/Ğ/g, 'g')
    .replace(/ğ/g, 'g')
    .replace(/Ü/g, 'u')
    .replace(/ü/g, 'u')
    .replace(/Ö/g, 'o')
    .replace(/ö/g, 'o')
    .replace(/Ç/g, 'c')
    .replace(/ç/g, 'c')
    .toLowerCase()
    .trim();
}

function CustomerSelect() {
  const {
    customers,
    selectedCustomer,
    fetchCustomers,
    setSelectedCustomer,
    fetchCustomerDetail,
    isLoading
  } = useCustomerStore();

  // Query state for input field and filtered results.
  const [query, setQuery] = useState('');
  const [filteredCustomers, setFilteredCustomers] = useState<CariData[]>([]);

  useEffect(() => {
    // Fetch customer list on component mount.
    fetchCustomers();
  }, [fetchCustomers]);

  // Update the filtered customer list when the query or customers array changes.
  useEffect(() => {
    const normalizedQuery = normalizeTurkish(query);
    if (normalizedQuery === '') {
      setFilteredCustomers(customers);
    } else {
      setFilteredCustomers(
        customers.filter(customer =>
          normalizeTurkish(customer.CariIsim).includes(normalizedQuery)
        )
      );
    }
  }, [query, customers]);

  if (isLoading && customers.length === 0) {
    return <p>Loading...</p>;
  }
  console.log('selectedCustomer', selectedCustomer);

  return (
    <div
      style={{
        marginTop: '16px',
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }}
    >
      <label
        htmlFor="customerSearch"
        style={{ display: 'block', marginBottom: '4px' }}
      >
        Cari Seç
      </label>
      <input
        type="text"
        id="customerSearch"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="CARİ ADI GİRİNİZ..."
        style={{
          width: '100%',
          padding: '8px',
          fontSize: '1em',
          boxSizing: 'border-box'
        }}
      />
      <ul
        style={{
          listStyleType: 'none',
          padding: 0,
          marginTop: '8px',
          maxHeight: '200px', // Adjust height as needed
          overflowY: 'auto',
          border: '1px solid #ccc'
        }}
      >
        {filteredCustomers.length > 0 ? (
          filteredCustomers.map((customer, index) => (
            <li
              key={index}
              onClick={() => {
                setSelectedCustomer(customer);
                fetchCustomerDetail(customer.CariKod);
                setQuery(customer.CariIsim); // Update the input with the selected customer's name.
              }}
              style={{
                padding: '8px',
                borderBottom: '1px solid #ccc',
                cursor: 'pointer'
              }}
            >
              {customer.CariIsim}
            </li>
          ))
        ) : (
          <li style={{ padding: '8px' }}>
            No matching customers found.
          </li>
        )}
      </ul>
    </div>
  );
}

export default CustomerSelect;
